import type { StateCreator } from 'zustand'
import { getActivityFeed, getPipelineStatus } from '@/shared/lib/api'
import type { PipelineStatus } from '@/shared/lib/api'

export interface ActivityItem {
  type: 'execution_entry' | 'workflow_update'
  id: string
  timestamp: string
  workflow_id: number
  action: string
  agent: string | null
  summary: string
  details: Record<string, unknown> | null
}

export interface ActivitySlice {
  activityFeed: ActivityItem[]
  activityLoading: boolean
  activityError: string | null
  fetchActivity: (since?: string) => Promise<void>
  pipelineStatus: PipelineStatus
  fetchPipelineStatus: () => Promise<void>
}

const DEFAULT_PIPELINE_STATUS: PipelineStatus = {
  active_enrichments: [],
  orchestrator_active: false,
}

export const createActivitySlice: StateCreator<ActivitySlice, [], [], ActivitySlice> = (set) => ({
  activityFeed: [],
  activityLoading: false,
  activityError: null,
  pipelineStatus: DEFAULT_PIPELINE_STATUS,

  fetchActivity: async (since?: string) => {
    set({ activityLoading: true, activityError: null })
    try {
      const items = await getActivityFeed(since)
      set({ activityFeed: items, activityLoading: false })
    } catch (err) {
      set({
        activityError: err instanceof Error ? err.message : 'Failed to fetch activity',
        activityLoading: false,
      })
    }
  },

  fetchPipelineStatus: async () => {
    try {
      const status = await getPipelineStatus()
      set({ pipelineStatus: status })
    } catch {
      // Silently ignore — pipeline status is best-effort
    }
  },
})
